import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import FaqAccordion from "@/components/site/FaqAccordion";
import SectionHeading from "@/components/site/SectionHeading";
import { PricingCard } from "@/components/site/cards";
import { ContactCTA } from "@/pages/Home";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/pricing").then((r) => setPlans(r.data)).catch(() => {});
    api.get("/faqs", { params: { } }).then((r) => setFaqs(r.data.filter((f) => f.category === "Pricing" || f.category === "Process"))).catch(() => {});
  }, []);

  return (
    <>
      <SEO title="Pricing" description="Transparent, fixed-scope pricing for websites, apps and enterprise platforms. Find the Web Vantage plan that fits your goals." path="/pricing" />
      <PageHero
        overline="Pricing"
        title="Simple pricing, serious value"
        subtitle="No hourly guesswork. Choose a plan or talk to us about a bespoke engagement — either way you'll know exactly what you're investing in."
        crumbs={[{ label: "Pricing" }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv">
          <div className="grid gap-6 lg:grid-cols-3">
            {plans.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.08}><PricingCard plan={p} /></Reveal>
            ))}
          </div>
          <Reveal className="mt-8 rounded-3xl border border-white/10 bg-white/[0.03] p-8 text-center">
            <p className="text-sm text-slate-400">
              All plans include enterprise SEO, responsive design, accessibility compliance and a dedicated project lead.
              Need something custom? <a href="/contact" className="font-medium text-vantage hover:underline">Let's talk.</a>
            </p>
          </Reveal>
        </div>
      </section>
      <section className="pb-20 lg:pb-28">
        <div className="container-wv grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
          <SectionHeading overline="FAQ" title="Pricing questions, answered" />
          <Reveal><FaqAccordion items={faqs} testid="pricing-faq" /></Reveal>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
